export const name = 'rnAUTH_EVENTS';

export default {
  signinSuccess:    'auth-signin-success',
  signinFailure:    'auth-signin-failed',
  signinCanceled:   'auth-signin-canceled',
  signoutSuccess:   'auth-signout-success',
  contextSuccess:   'auth-context-success',
  contextFailure:   'auth-context-failure',
  sessionTimeout:   'auth-session-timeout',
  authenticated:    'auth-authenticated',
  notAuthenticated: 'auth-not-authenticated'
  // notAuthorized:    'auth-not-authorized'
};
